import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import { FC } from "react";
import AlertDialogComponent from "../../molecule/AlertDialog/AlertDialogComponent";
import { DELETE_DIALOG_MESSAGE } from "../../../utils/constants";

interface ModalComponentProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  isAlertOpen?: boolean;
  setIsAlertOpen?: (isOpen: boolean) => void;
  alertTitle?: string;
  alertText?: string;
  handleDelete?: () => void;
  alertButtonText?: string;
  size?: string;
}

const ModalComponent: FC<ModalComponentProps> = ({
  isOpen,
  onClose,
  title,
  children,
  isAlertOpen,
  setIsAlertOpen,
  alertTitle = "Eliminar item",
  alertText = DELETE_DIALOG_MESSAGE,
  handleDelete,
  alertButtonText = "Eliminar",
  size = "4xl",
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={size} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize="xl" fontWeight="bold">
          {title}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb="0">{children}</ModalBody>
      </ModalContent>

      {isAlertOpen && setIsAlertOpen && (
        <AlertDialogComponent
          isOpen={isAlertOpen}
          setIsOpen={setIsAlertOpen}
          title={alertTitle}
          text={alertText}
          handleButton={handleDelete}
          buttonText={alertButtonText}
        />
      )}
    </Modal>
  );
};

export default ModalComponent;
